<template>
  <div>
    <!-- <statics-card
        v-if="$can('read', 'ADMIN_B2C')"
        :data="dataStaticsAdminTypeTwo"
        title-card="Estatísticas Admin Total"
    />
    <statics-card
        v-if="$can('read', 'ADMIN_B2C')"
      :data="dataStatics"
      title-card="Estatísticas Administrador"
    />

    <statics-card
        v-if="$can('read', 'Vendedor')"
        :data="dataStaticsCliente"
        title-card="Estatísticas Vendedores"
    />

    <statics-card
        v-if="$can('read', 'CLIENTE_B2C')"
        :data="dataStaticsCliente"
        title-card="Estatísticas Clientes"
    />

    <statics-card
        v-if="$can('read', 'Afiliado')"
        :data="dataStaticsCliente"
        title-card="Estatísticas Afiliados"
    />

    <statics-card
        v-if="$can('read', 'Padrinho')"
        :data="dataStaticsCliente"
        title-card="Estatísticas Apadrinhados"
    /> -->
    <component :is="dashboardComponent" />
  </div>
</template>

<script>
import { BCard, BCardText } from 'bootstrap-vue'
import StaticsCard from '@/components/deashboard/StaticsCard.vue'
import { mapGetters } from 'vuex'
import DashboardVendedor from './DashboardVendedor.vue'
import DashboardAdmin from './DashboardAdmin.vue'
import DashboardPadrinho from './DashboardPadrinho.vue'
import DashboardAfiliado from './DashboardAfiliado.vue'

export default {
  components: {
    BCard,
    BCardText,
    StaticsCard,
    DashboardVendedor,
    DashboardAdmin,
    DashboardPadrinho,
    DashboardAfiliado,
  },
  computed: {
    ...mapGetters({
      dataStatics: 'appDashboards/GET_STATICS_ADMIN',
      dataStaticsCliente: 'appDashboards/GET_STATICS_CLIENTE',
      dataStaticsAdminTypeTwo: 'appDashboards/GET_STATICS_ADMIN_TYPE_TWO',
    }),
    dashboardComponent() {
      // Use a lógica de permissão ($can) para decidir
      // A ordem pode ser importante se um usuário puder ter múltiplas roles
      if (this.$can('read', 'ADMIN_B2C')) {
        return DashboardAdmin // Retorna a instância do componente importado
      }
      if (this.$can('read', 'Vendedor')) {
        return DashboardVendedor
      }
      if (this.$can('read', 'Afiliado')) {
        return DashboardAfiliado
      }
      if (this.$can('read', 'Padrinho')) {
        return DashboardPadrinho
      }
      // Retorne um componente padrão ou null se nenhum corresponder
      return null // Ou return DashboardDefault
    },
  },
  mounted() {
    // /dashboard/admin
    this.$store.dispatch('appDashboards/GET_STATICS_ADMIN_TYPE_ONE')
    this.$store.dispatch('appDashboards/GET_STATICS_ADMIN_TYPE_TWO')
    this.$store.dispatch('appDashboards/FETCH_STATICS_CLIENTE')
  },
}
</script>

<style>

</style>
